export const getEveryDayDateStringList = (from: any, to: any) => {
  let currentDate = new Date(from.replace(/-/g, '/'))
  let rstList: any[] = []
  while (true) {
    if (currentDate.getTime() > to.getTime()) {
      break
    }
    rstList.push(`${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`)
    currentDate = new Date(currentDate.setDate(currentDate.getDate() + 1))
  }
  return rstList
}

export const getDaysOfMonth = (year: any, month: any) => {
  switch (month) {
    case 1:
    case 3:
    case 5:
    case 7:
    case 8:
    case 10:
    case 12:
      return 31
    case 4:
    case 6:
    case 9:
    case 11:
      return 30
    case 2:
      return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) ? 29 : 28
    default:
      return 0
  }
}

export const getTitleStringByType = (filters: any) => {
  let type = filters.sectionType
  let year = filters.year
  let month = filters.month
  let quarter = filters.quarter
  let day = filters.day
  if (type === 'year') {
    return `${year}年`
  } else if (type === 'quarter') {
    return `${year}年第${quarter}季度`
  } else if (type === 'month') {
    return `${year}年${month}月`
  } else if (type === 'day') {
    return `${year}年${month}月${day}日`
  }
  return ''
}
